<template>
  <div v-if="isRechercheDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
    </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <DataTable
          class="p-datatable-sm"
          :value="dossiers"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cle"
          @row-select="onRowSelect"
          :paginator="true"
          :rows="100"
          :rowClass="rowClass"
          paginatorPosition="both"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} dossiers"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column field="liaison" :sortable="false">
          <template #body="slotProps">
            <Button
                type="button"
                @click="obtenirRolesLiaisonPossibles(slotProps.data)"
                icon="pi pi-link"
            ></Button>
          </template>
        </Column>
        <Column
            field="numeroCardexAfficher"
            header="Numéro Cardex"
            :sortable="true"
        ></Column>
        <Column
            field="numeroDossier"
            header="No Dossier"
            :sortable="true"
        ></Column>
        <Column
            field="reference1"
            header="Réf. 1"
            :sortable="true"
        ></Column>
        <Column
            field="reference2"
            header="Réf. 2"
            :sortable="true"
        ></Column>
        <Column
            field="reference3"
            header="Réf. 3"
            :sortable="true"
        ></Column>
        <Column
            field="severiteAfficher"
            header="Sév."
            :sortable="true"
        ></Column>
        <Column
            field="confidentialiteAfficher"
            header="Conf."
            :sortable="true"
        ></Column>
        <Column
            field="typeAfficher"
            header="Type"
            :sortable="true"
        ></Column>
        <Column
            field="categorieAfficher"
            header="Catégorie"
            :sortable="true"
        ></Column>
        <Column field="periode" header="Période" :sortable="true">
          <template #body="slotProps">
            {{ $commun.formatDateHeure(slotProps.data.periode) }}
          </template>
        </Column>
        <Column
            field="statutAfficher"
            header="Statut"
            :sortable="true"
        ></Column>
        <Column
            field="fondeAfficher"
            header="Fondé"
            :sortable="true"
        ></Column>
        <Column field="debutDate" header="Date de début" :sortable="true">
          <template #body="slotProps">
            {{ $commun.formatDateHeure(slotProps.data.debutDate) }}
          </template>
        </Column>
        <Column field="finDate" header="Date de fin" :sortable="true">
          <template #body="slotProps">
            {{ $commun.formatDateHeure(slotProps.data.finDate) }}
          </template>
        </Column>
        <Column
            field="descriptif"
            header="Descriptif"
            :sortable="true"
        ></Column>
        <Column
            field="creerPar"
            header="Intervenant"
            :sortable="true"
        ></Column>
      </DataTable>
    </div>
  </div>

  <ChoixRole
      :listeRoles="listeRoles"
      v-show="isChoixRoleVisible"
      @fermerChoixRole="fermerChoixRole"
      @lier="lier"
  />
</template>

<script>
import ChoixRole from "./ChoixRole.vue";
import {mapGetters} from "vuex";

export default {
  name: "ResultatLiaisonDossier",
  props: ['dossiers', 'isRechercheDataLoading'],
  components: {
    ChoixRole
  },
  data() {
    return {
      role: null,
      listeRoles: [],
      selection: null,
      isChoixRoleVisible: false,
      dossierALier: null,
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      dossiersLiaisonHistorique: 'dossier/dossiersLiaisonHistorique',
    })
  },
  methods: {
    fermerChoixRole() {
      this.isChoixRoleVisible = false;
    },
    onRowSelect(event) {
      this.$store.commit('dossier/AJOUT_DOSSIER_LIAISON_HISTORIQUE', event.data.cle)
      this.$router.push({
        name: "dossierConsulter",
        params: {
          cle: event.data.cle,
          site: event.data.site,
        },
      })
    },
    obtenirRolesLiaisonPossibles(rowData) {
      let genre = this.$route.params.genre
      this.$store
          .dispatch("dossier/obtenirRolesLiaisonAction", {
            moduleSource: genre,
            moduleDestination: "DO",
            categorie: rowData.categorie
          })
          .then((res) => {
            this.listeRoles = res.data.sort(this.$commun.compareLibelles);
            this.dossierALier = rowData;
            if (this.listeRoles.length > 1) {
              this.isChoixRoleVisible = true;
            } else {
              this.lier(this.listeRoles[0].valeur);
            }
          });
    },
    lier(roleParam) {
      this.$root.$refs.breadcrumbComp.source.newLiaison = true;
      this.$root.$refs.breadcrumbComp.destination = {
        cle: this.dossierALier.cle, site: this.dossierALier.site, genre: "DO",
        module: this.dossierALier
      };
      this.$root.$refs.breadcrumbComp.contextRole = roleParam;
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    rowClass(data) {
      return this.dossiersLiaisonHistorique.includes(data.cle) ? 'row-previously-selected': null;
    },

  },
};
</script>

<style scoped>
  ::v-deep(.row-previously-selected) {
      color: var(--row-previously-selected) !important;
  }
</style>

